import { render, staticRenderFns } from "./Titles.vue?vue&type=template&id=7630826b&scoped=true&"
import script from "./Titles.vue?vue&type=script&lang=js&"
export * from "./Titles.vue?vue&type=script&lang=js&"
import style0 from "./Titles.vue?vue&type=style&index=0&id=7630826b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7630826b",
  null
  
)

export default component.exports